import React from 'react';
import Carousel from 'brastrap/common/carousel/Carousel';
import Image from 'brastrap/common/image/Image';
import Link from 'brastrap/containers/link/LinkContainer';
import type {
  Thumbnails as Props,
  BaseCarouselOptions,
} from './product-gallery.types';

const STYLE_PREFIX = 'c-product-gallery';
const VIDEO_IMAGE = 'video';

const Thumbnail = ({
  image,
  index,
  setMainImage,
  imageIndexToHighlight,
}: {
  image: ContentfulImage,
  index: number,
  setMainImage: number => void,
  imageIndexToHighlight: number,
}) => (
  <Link
    href={image.detail || '#'}
    onClick={e => {
      e.preventDefault();
      return setMainImage ? setMainImage(index) : null;
    }}
  >
    {image.type === VIDEO_IMAGE && (
      <div className={`${STYLE_PREFIX}__thumbnail-video-overlay`} />
    )}
    <Image
      className={`${STYLE_PREFIX}__img ${
        imageIndexToHighlight > -1 && index === imageIndexToHighlight
          ? `${STYLE_PREFIX}__img--highlight`
          : ''
      }`}
      src={image.thumbnail}
      alt={image.alt}
      fetchPriority="high"
    />
  </Link>
);

const ThumbnailGalleryCarousel = (props: {
  thumbnailCarouselOptions: BaseCarouselOptions,
  images: ContentfulImage[],
  setRefOnParent: (?Carousel) => void,
  setMainImage: number => void,
  isForMobile: boolean,
  arrows: boolean,
  imageIndexToHighlight: number,
}) => (
  <div
    className={`${STYLE_PREFIX}__carousel--thumbnails ${
      props.isForMobile ? `${STYLE_PREFIX}__carousel--thumbnails-mobile` : ''
    }`}
  >
    <Carousel
      isMobile={props.isForMobile}
      thumbnailIndex={props.imageIndexToHighlight}
      verticalScroll={!props.isForMobile}
      arrows={props.arrows}
      ref={(carousel: ?Carousel) => props.setRefOnParent(carousel)}
      {...props.thumbnailCarouselOptions}
    >
      {props.images.map((image, index) => (
        <div key={image.id || index}>
          <div
            className={`${STYLE_PREFIX}__thumbnail ${
              props.isForMobile ? `${STYLE_PREFIX}__thumbnail--vertical` : ''
            }`}
          >
            <Thumbnail
              image={image}
              index={index}
              setMainImage={props.setMainImage}
              imageIndexToHighlight={props.imageIndexToHighlight}
            />
          </div>
        </div>
      ))}
    </Carousel>
  </div>
);

const ThumbnailGallery = (props: {
  images: ContentfulImage[],
  setMainImage: number => void,
  imageIndexToHighlight: number,
}) => (
  <ul className="c-product-gallery__thumbnails" role="listbox">
    {props.images.map((image, index) => (
      <li key={image.id || index} className="c-product-gallery__thumbnail">
        <Thumbnail
          image={image}
          index={index}
          setMainImage={props.setMainImage}
          onThumbnailImageSelect={() => {}}
          imageIndexToHighlight={props.imageIndexToHighlight}
        />
      </li>
    ))}
  </ul>
);

const ProductGalleryThumbnails = (props: Props) =>
  props.displayCarousel ? (
    <ThumbnailGalleryCarousel
      {...props}
      imageIndexToHighlight={props.currentImageIndex}
    />
  ) : (
    <ThumbnailGallery
      {...props}
      imageIndexToHighlight={props.currentImageIndex}
    />
  );

export default ProductGalleryThumbnails;
